import StringHelperService from './string-helper.service';

export default {
  textboxLabel(fieldInfo) {
    return `<label class="k-textbox-label" for="${fieldInfo.field}">${
      fieldInfo.label === undefined ? StringHelperService.fieldToTitle(fieldInfo.field) : fieldInfo.label
    }</label>`;
  },
  textareaInput(fieldInfo, rows) {
    return `<div class="add-edit-${StringHelperService.toKebabCase(fieldInfo.field)} form-field form-group">
    ${this.textboxLabel(fieldInfo)}
      <textarea v-model.lazy="formData.${fieldInfo.field}" v-bind:rows="${rows}" class="k-textarea"></textarea>
      </div>`;
  },
  textInput(fieldInfo) {
    return `<div class="add-edit-${StringHelperService.toKebabCase(fieldInfo.field)} form-field form-group">
      ${this.textboxLabel(fieldInfo)}
      <input id="${fieldInfo.field}"
             autofocus
             class="k-textbox"
             v-model.lazy="formData.${fieldInfo.field}"
             ${fieldInfo.required ? 'required' : ''}
             ${fieldInfo.type === undefined ? '' : `type="${fieldInfo.type}"`}
             ${fieldInfo.disableTabbing ? 'tabindex="-1"' : ''}
             ${fieldInfo.min ? `min="${fieldInfo.min}"` : ''}
             ${fieldInfo.max ? `max="${fieldInfo.max}"` : ''} />
    </div>`;
  },
  checkboxInput(fieldInfo) {
    return `
    <div class="form-checkbox">
      <input id="${fieldInfo.field}" type="checkbox" v-model="formData.${fieldInfo.field}" />
      <label for="${fieldInfo.field}">${StringHelperService.fieldToTitle(fieldInfo.field)}</label>
    </div>`;
  },
  radioInput(fieldName, fieldValue, changeFunc) {
    return `<input type="radio" id="${fieldName}" name="${fieldValue}" value="${fieldName}" v-model="formData.${fieldValue}" class="k-radio" v-on:change="${changeFunc}" />
    <label for="${fieldName}" class="k-radio-label">${fieldName}</label>`;
  }
};
